import { MouseEvent, useCallback,useMemo, useState } from 'react'

import useTokens from '@/hooks/use-tokens'

import { COLUMNS_KEY } from '../helpers'
import type { ViewPropsCommon } from '../types'
import type { ViewProps } from './types'
import View from './view'

const Container = ({ topCoinsData, isLoading, columns, onClickTokenItem }: ViewPropsCommon) => {
  const { tokenListMap, reUsdTokenInfo } = useTokens()
  const columnAction = useMemo(() => {
    return columns.find((col) => col.key === COLUMNS_KEY.actionsSpot)
  }, [columns])
  const [currentTargetEl, setCurrentTargetEl] = useState<HTMLButtonElement | null>(null)
  const [tokenAddressInChart, setTokenAddressInChart] = useState('')

  const tokenInChart = useMemo(() => {
    const tokenA = tokenListMap.get(tokenAddressInChart)
    if (tokenA && tokenA.address !== reUsdTokenInfo.address) {
      return {
        tokenA,
        tokenB: reUsdTokenInfo,
      }
    }
    return null
  }, [tokenListMap, tokenAddressInChart, reUsdTokenInfo])

  const onOpenMoreMenu = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    setCurrentTargetEl(event.currentTarget)
  }, [])

  const onCloseMoreMenu = useCallback(() => {
    setCurrentTargetEl(null)
  }, [])

  const onOpenCandleChart = useCallback((tokenMint: string) => {
    setCurrentTargetEl(null)
    setTokenAddressInChart(tokenMint)
  }, [])

  const computedProps: ViewProps = {
    topCoinsData,
    isLoading,
    onOpenMoreMenu,
    onCloseMoreMenu,
    columnAction,
    currentTargetEl,
    tokenInChart,
    onOpenCandleChart,
    setTokenAddressInChart,
    onClickTokenItem,
  }

  return <View {...computedProps} />
}

export default Container
